import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import fxViewcomponents from '@/components/fxView' 

import login from '@/components/fxView/users/login'
import register from '@/components/fxView/users/register_ib.vue'
import forgotPassword from '@/components/fxView/users/forgot_password'
import ResetPasswordFromHash from '@/components/fxView/users/ResetPasswordFromHash'
import dashboard from '@/components/fxView/users/dashboard' 
import twoFa from '@/components/fxView/users/2FA'
import profile from '@/components/fxView/users/profile'
import changeUserPassword from '@/components/fxView/users/change_password'

import step_one from '@/components/fxView/registerSteps/step1'
import step_four from '@/components/fxView/registerSteps/step4'
import step_five from '@/components/fxView/registerSteps/step5'

import client_details from '@/components/fxView/client/client_details'
import trading_accounts from '@/components/fxView/trading-accounts/list'

import support from '@/components/fxView/supports/index'
import view from '@/components/fxView/supports/view'

import sub_ib_detail from '@/components/fxView/ib/sub_ib_detail'
import affiliate_earnings from '@/components/fxView/ib/affiliate_earnings'

import referal_link from '@/components/fxView/referal-link/referal_link'


import withdrawal from '@/components/fxView/withdrawal/withdrawal'
import request_verify from '@/components/fxView/withdrawal/request_verify'
import withdrawalCommListing from '@/components/fxView/withdrawal/withdrawal_commission_listing'

import promotional_tools from '@/components/fxView/promotion/promotional_tools'

Vue.use(Router)
const router =  new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'fxView.login', component: login },
    { path: '/register',name: 'fxView.register',component: register},
    { path: '/forgot-password', name: 'fxView.forgotPassword', component: forgotPassword },
    { path: '/forgot/password', name: 'fxView.ResetPasswordFromHash', component: ResetPasswordFromHash },
    {
      path: '/',
      component:fxViewcomponents,
      children: [
        { path: '/security', name: 'fxView.twoFa', component: twoFa },
        { path: '/profile', name: 'fxView.profile', component: profile },
        { path: '/dashboard', name: 'fxView.dashboard', component: dashboard },
        { path: '/change-password', name: 'fxView.changeUserPassword', component: changeUserPassword },

        { path: '/step1', name: 'fxView.step_one', component: step_one },
        { path: '/step2', name: 'fxView.step_four', component: step_four },
        { path: '/step3', name: 'fxView.step_five', component: step_five },

        { path: '/client-details', name: 'client.client_details',  component: client_details },
        { path: '/trading-accounts', name: 'client.trading_accounts',  component: trading_accounts },

        { path: '/support/:tabName', name: 'fxView.support', component: support },
        { path: '/view', name: 'fxView.view', component: view },

        { path: '/sub-ib-detail', name: 'ib.sub_ib_detail',  component: sub_ib_detail },
        { path: '/affiliate-earnings', name: 'affiliate.affiliate_earnings',  component: affiliate_earnings },

        { path: '/referal-link', name: 'referal.referal_link',  component: referal_link },

        {  path: '/withdrawal',  name: 'fxView.withdrawal', component: withdrawal},
        {  path: '/commission-verify',  name: 'withdrawal.request_verify', component: request_verify,  props : true },
        { path: '/withdrawal-commission-list',  name: 'withdrawal.withdrawalCommListing', component: withdrawalCommListing },

        { path: "/promotional-tools",  name: 'promotion.promotional_tools',  component: promotional_tools}
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {

  let userStateVariable = store.state.user
  if(userStateVariable == ''){
    userStateVariable= {}
  }
  if (to.name !== 'fxView.login' && to.name !== 'fxView.register' && to.name !== 'fxView.forgotPassword' && to.name !== 'fxView.ResetPasswordFromHash' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) {
        localStorage.setItem("lastPath", to.path);
        next({ name: 'fxView.login' })
  }

  else if ((to.name == 'fxView.step_one' || to.name == 'fxView.step_four' || to.name == 'fxView.step_five') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.step) >= 3)) next({ name: 'fxView.dashboard' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn  && (to.name == 'fxView.login' || to.name == 'fxView.register' || to.name == 'fxView.forgotPassword' || to.name == 'fxView.ResetPasswordFromHash')) next({ name: 'fxView.dashboard' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.login' || to.name == 'fxView.register' || to.name == 'fxView.forgotPassword' || to.name == 'fxView.ResetPasswordFromHash')) next({ name: 'fxView.dashboard' })

  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js